<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1100"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          <div>
            <div>Ticket History - {{serialNumber}}</div>
            <div style="font-size: 12px; font-weight: normal"><i>{{decodedSerialNumber}}</i></div>
          </div>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-card id="printableArea" flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
              <TicketWithComments
                v-for="(item, index) in tickets"
                :index="index"
                :key="item.id"
                :ticket="item"
              >
              </TicketWithComments>
              <div
                v-if="tickets && tickets.length === 0"
                class="pa-3"
                style="background-color: #424242; color: white; text-align: center;"
              >
                NO TICKETS
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <!--<v-btn color="green" text @click="onPrintClick()">Print</v-btn>-->
        <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import decodeSerialNumber from '../../decodeSerialNumber';
import TicketWithComments from './TicketWithComments.vue';

export default {
  components: {
    TicketWithComments,
  },

  props: {
    dialog: Boolean,
    serialNumber: String,
    aligner: Object,
    tickets: Array,
  },

  computed: {
    decodedSerialNumber() {
      if (this.serialNumber) {
        const decodedSerialNumber = decodeSerialNumber(this.serialNumber.toUpperCase());
        if (decodedSerialNumber) {
          return `${decodedSerialNumber.marketingName} ${decodedSerialNumber.buildMonth}/${decodedSerialNumber.buildYear}`;
        }
      }

      return '...';
    },
  },

  methods: {
    onRefreshClick() {
      this.$emit('refresh');
    },

    onCloseClick() {
      this.$emit('close');
    },

    onPrintClick() {
    },
  },
};
</script>
